import DOMPurify from 'dompurify';
import { forwardRef, useRef } from 'react';
import styled from 'styled-components';

import { useGlobalStore } from '../../state/globalStore';

interface Props {
  content: string;
  id?: string;
}
export const StylableText = forwardRef(({ content, id }: Props) => {
  const leadCaptureProperties = useGlobalStore((state) => state.leadCapture);
  const { alignment } = leadCaptureProperties;
  const wrapperRef = useRef(null);

  return (
    <Wrapper id={id} align={alignment} ref={wrapperRef}>
      <div
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content, { ADD_ATTR: ['target'] }) }}
      ></div>
    </Wrapper>
  );
});

const Wrapper = styled.div<{ align: string }>`
  position: relative;
  width: 100%;
  word-break: break-word;
  p {
    margin: 0;
  }
  p:empty {
    /**
      For empty lines, the tip tap editor represents it with empty paragraph. 
      But when it renders, the tiptap editor injects a br into it.
      Since we are not using tiptap editor for rendering in embed, we need to inject the same height(19.2) to empty paragraph 
    */
    height: 19.2px;
    margin: 0;
  }
  margin-bottom: 14.5px;
  > div {
    outline: none;
    padding: 4px 4px;
    line-height: 1.2;
    border-radius: 5px;
  }
  ul {
    list-style-type: disc;
    padding-left: 25px;
  }

  ol {
    list-style-type: decimal;
    padding-left: 25px;
  }

  a {
    text-decoration-color: white;
  }

  list-style: revert;
`;
